/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_About_P2Inputs */

const en_pc_online_about_p2 = /** @type {(inputs: Pc_Online_About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use it to check a document on a borrowed computer, merge two files on a Chromebook, or try PdfCraft before installing it. For daily work, printing and large files, the desktop app is the better fit.`)
};

const zh_pc_online_about_p2 = /** @type {(inputs: Pc_Online_About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以用它在借来的电脑上查看文档、在 Chromebook 上合并两个文件，或在安装前先试用 PdfCraft。日常工作、打印和处理大文件，桌面版更合适。`)
};

/**
* | output |
* | --- |
* | "Use it to check a document on a borrowed computer, merge two files on a Chromebook, or try PdfCraft before installing it. For daily work, printing and large ..." |
*
* @param {Pc_Online_About_P2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_about_p2 = /** @type {((inputs?: Pc_Online_About_P2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_About_P2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_about_p2(inputs)
	return zh_pc_online_about_p2(inputs)
});
export { pc_online_about_p2 as "pc.online.about_p2" }